import { Navigate } from "react-router-dom";
import BaseLayout from "../components/Layouts/BaseLayout";

// Rutas
import adminRoutes from "./AdminRoutes";
import portalRoutes from "./PortalRoutes";
import rootRoutes from "./RootRoutes";

// Paths
import pathRoutes from "./pathRoutes";
import Layout from "../components/Layouts/Layout";

const routes = [
  {
    element: <Layout IsAdminMode={true} />,
    children: [
      {
        path: pathRoutes.ADMIN,
        children: adminRoutes,
      },
    ],
  },
  {
    element: <Layout IsAdminMode={false} />,
    children: [
      {
        path: pathRoutes.PORTAL,
        children: portalRoutes,
      },
    ],
  },
  {
    path: pathRoutes.ROOT_LOGIN,
    element: <BaseLayout />,
    children: rootRoutes,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
